import { shortenNumber } from '@cian/utils';

import { IPromoInfo } from '../../../types/newbuildingPromos';

export const getMaxCredit = (promo: IPromoInfo): string => {
  const maxCredit = promo.mortgageParams?.maxCredit;

  if (!maxCredit) {
    return '—';
  }

  const shortenMaxCredit = shortenNumber(maxCredit, {
    billionPostfix: 'млрд',
    fractionalLength: 1,
    millionPostfix: 'млн',
    separator: ',',
    thousandPostfix: 'тыс',
    withoutPostfix: false,
  });

  return `до ${shortenMaxCredit} ₽`;
};
